module.exports = __webpack_public_path__ + "static/media/clearbit-mobiles-1.99459a9f.jpg";